import { useState } from 'react';
import { isSupabaseError } from '../../constants/supabaseErrors';

type Props = {
  onConfirm: () => Promise<unknown>;
  onClose: () => void;
};

export function useConfirmDeleteDialog(props: Props) {
  const [isPending, setIsPending] = useState(false);
  const [serverError, setServerError] = useState<string | null>(null);

  async function handleConfirm() {
    setIsPending(true);
    setServerError(null);

    try {
      await props.onConfirm();
      props.onClose();
    } catch (error: unknown) {
      setServerError(isSupabaseError(error) ? error.message : 'Une erreur est survenue.');
    } finally {
      setIsPending(false);
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    isPending,
    serverError,
    handleConfirm,
    handleClose,
  };
}
